export default (type, colors) => {
  const styles = {
    type1: {
      'collections__c-tabs__tab': {
        fontSize: '16px',
        paddingLeft: 5,
        paddingRight: 5,
      },
      'collections__flag__content__h2': {
        color: colors.dark,
        fontSize: '24px'
      },
      'collections-results-panel': {
        customCSS: `
          .button-dropdown__trigger {
            margin: 0.5rem;
          }
        `
      }
    }
  }

  return styles[type]
}



// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/collections.js